import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnInit
} from '@angular/core';
import { ISort } from 'src/app/library/interfaces/filters/sort/sort';

@Component({
    selector: 'filter-selected-sorts',
    templateUrl: './filter-selected-sorts.component.html',
    styleUrls: ['./filter-selected-sorts.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FilterSelectedSortsComponent implements OnInit {
    @Input() selectedSorts: ISort[];
    @Input() allowDisableRemove: boolean = false;

    constructor() {}

    ngOnInit() {}
}
